<template>
  <div class="diagram-actions">
    <div
      role="button"
      class="btn-container-bottom captures-description"
      @click="!$store.state.isWorkflowDisabled && addRole($event)"
      :class="{ 'disabled': $store.state.isWorkflowDisabled }"
    >
      <v-icon size="small">mds:add</v-icon>
      Add lane
    </div>

    <div
      v-if="hasEvents"
      role="button"
      class="btn-container-bottom captures-description"
      @click="!$store.state.isWorkflowDisabled && $emit('add-shape', {}, { parentEventId: 'start', createNewLaneIfNoLaneId: true })"
      :class="{ 'disabled': $store.state.isWorkflowDisabled }"
    >
      <v-icon size="small">mds:add</v-icon>
      Add start point
    </div>

    <v-tooltip location="bottom" max-width="220" open-delay="500" v-if="hasEvents">
      <template v-slot:activator="{ props }">
        <div
          role="button"
          class="btn-container-bottom captures-description"
          @click="!$store.state.isWorkflowDisabled && $emit('add-group', selectedEventId)"
          :class="{ 'disabled': $store.state.isWorkflowDisabled }"
          v-bind="props"
        >
          <v-icon size="small">mds:add</v-icon>
          Add group
        </div>
      </template>
      <div>
        <p>
          Click here to add a new group. After adding 2 groups you will get a vertical divider that you can move sideways.
        </p>
      </div>
    </v-tooltip>
    <div
      v-if="hasEvents"
      role="button"
      class="btn-container-bottom captures-description"
      @click="!$store.state.isWorkflowDisabled ? openWorkflowFromCodeDialog = true : undefined"
      :class="{ 'disabled': $store.state.isWorkflowDisabled }"
    >
      <v-icon size="small" icon="mdi-github" />
      Generate from code
    </div>
    <workflow-from-code
      :modelValue="openWorkflowFromCodeDialog"
      @update:modelValue="(val) => openWorkflowFromCodeDialog = val"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { EventBus } from '@/event-bus/event-bus.js'
import { diagramHelpers } from '@/mixins/diagramHelpers'
import WorkflowFromCode from '@/components/WorkflowFromCode.vue'

export default {
  components: { WorkflowFromCode },
  mixins: [diagramHelpers],

  props: {
    selectedEvent: Object,
    requirementTypes: Array,
    baseData: Object,
    svgGraph: Object,
    svgGroups: Object,
    svgLanes: Object
  },

  data: () => ({
    commentsDialog: false,
    commentsDialogVote: null,
    feedbackDialog: false,
    openWorkflowFromCodeDialog: false
  }),

  computed: {
    ...mapState({ workflow: state => state.workflow.workflow }),
    selectedEventId () {
      return this.$route.params.eventId
    },
    hasEvents () {
      return this.workflow?.eventsJson && this.workflow.eventsJson.length
    },
    addConnectionDisabled () {
      const res = (this.selectedEvent?.childIds?.length > 0) && (this.selectedEvent?.type !== 'bpmn:ExclusiveGateway')
      return res
    }
  },

  methods: {
    handleDragStart (ev) {
      ev.dataTransfer.setData('text/plain', ev.target.dataset.cardTypeId)
    },
    addRole () {
      const roleName = 'Lane ' + ((this.workflow.lanes?.length || 0) + 1)
      this.addLane(this.svgGraph, this.svgLanes, this.svgGroups, this.workflow, roleName, true)
    },
    openCommentDialog (vote = null) {
      this.commentsDialogVote = vote
      this.commentsDialog = true
    },

    closeCommentsDialog () {
      this.commentsDialog = false
      this.commentsDialogVote = null
    },

    eventBusEmitEnableTargets () {
      EventBus.$emit('enable-connection-targets', true)
    }
  }
}
</script>

<style scoped>
.v-tooltip__content {
  background: white;
  color: var(--color-primary);
  border-radius: 10px;
}

.v-tooltip__content code {
  background: var(--color-primary);
  color: white;
}

.dnd-card-types-container {
  display: flex;
  align-items: center;
}

.add-card-of-type {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  cursor: move;
}
</style>
